// Componente reutilizável para renderizar documentos legais (Termos, Privacidade)
// Renderiza Markdown em tema escuro, com coluna de leitura confortável.
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { marked } from 'marked';

import {
    PageWrapper,
    TopBar,
    LogoImg,
    BackButton,
    DocContainer,
    DocBody,
    FooterNote
} from './styled';

/**
 * @param {{ title: string, lastUpdate: string, markdown: string }} props
 */
const LegalDocument = ({ title, lastUpdate, markdown }) => {
    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const html = marked.parse(markdown || '');

    return (
        <PageWrapper>
            <TopBar>
                <LogoImg
                    src="/icons/logo_tiq_chat.png"
                    alt="TiqChat"
                    onClick={() => history.push('/')}
                />
                <BackButton onClick={() => history.push('/')} aria-label="Voltar para a página inicial">
                    ← Voltar ao início
                </BackButton>
            </TopBar>

            <DocContainer>
                <h1>{title}</h1>
                <p className="last-update">Última atualização: {lastUpdate}</p>
                <DocBody dangerouslySetInnerHTML={{ __html: html }} />
                <FooterNote>
                    Stonel19 Soluções em IA Gen Ltda · CNPJ 61.577.764/0001-39
                </FooterNote>
            </DocContainer>
        </PageWrapper>
    );
};

export default LegalDocument;
